import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const cardiofitnessApiService = createApi({
  reducerPath: "cardiofitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createCardio: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `cardiofitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getCardio: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `cardiofitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateCardio: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `cardiofitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateCardioMutation,
  useGetCardioQuery,
  useUpdateCardioMutation,
} = cardiofitnessApiService;
